export const API_KEY = "AIzaSyDp-EbaEolySUT22zw7gqj-FqTQkNh6tPk";
export const GEOCODING_API_KEY = "AIzaSyDdESw31e8pyV5wnhiAtk3w16KySS2FhP0";
export const GEOCODING_URL = `https://maps.googleapis.com/maps/api/geocode/json?key=${GEOCODING_API_KEY}&`;
